import React from "react";
import ClaimsPresenter from "./ClaimsPresenter";
import Shell from "../../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DTOClaims from "./DTOClaims";
import { useTranslation } from "react-i18next";

function ClaimsController() {
  const { t, i18n } = useTranslation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <DTOClaims />
        <ClaimsPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default ClaimsController;
